import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DialogActions, DialogContent } from '@material-ui/core';
import H3 from '@base/H3/H3';
import H6 from '@base/H6/H6';
import Button from '@base/Button/Button';
import { Fonts, Spacings } from '@styles/index';
import Coin from '@icon/Coin';
import { getPlusSubscriptionInfoLatest } from '@selectors/subscription';
import useNotEnoughCredits from './useNotEnoughCredits';

const ContentContainer = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TotalContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template: 1fr / repeat(3, max-content);
  grid-column-gap: ${Spacings.SPACING_1B};
  margin: ${Spacings.SPACING_2B} 0px ${Spacings.SPACING_8B};
`;

const Text = styled(H6)`
  font-weight: ${Fonts.REGULAR};
`;

const StyledBtn = styled(Button)`
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-4) 0%,
    var(--color-i-blue-3) 100%
  );
`;

const NotEnoughCredits = ({
  Modal,
  show,
  onClose,
  requiredCredits,
  goalUID,
  goalSlug,
  selectedCombatInfo
}) => {
  const hasSubscription = useSelector(getPlusSubscriptionInfoLatest(goalUID));

  // eslint-disable-next-line no-nested-ternary
  const purchaseType = hasSubscription
    ? hasSubscription.time_remaining
      ? 'extension'
      : 'renewal'
    : 'new';

  const { goToSubscriptionPage, openArticle } = useNotEnoughCredits({
    goalSlug,
    goalUID,
    selectedCombatInfo,
    purchaseType
  });

  return (
    <Modal dialogState={show} onClose={onClose}>
      <ContentContainer>
        <H3>Not enough credits</H3>
        <TotalContainer>
          <Text>You need</Text>
          <Coin size="18px" viewBox="0 0 32 32" />
          <Text>{`${requiredCredits} to enroll in this contest`}</Text>
        </TotalContainer>
      </ContentContainer>
      <DialogActions>
        <Button
          label="Get more credits"
          variant="hollow"
          color="black"
          onClick={openArticle}
        />
        <StyledBtn label="Get subscription" onClick={goToSubscriptionPage} />
      </DialogActions>
    </Modal>
  );
};

NotEnoughCredits.propTypes = {
  Modal: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requiredCredits: PropTypes.number.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  selectedCombatInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

export default NotEnoughCredits;
